import React from "react";
import CountUp from "react-countup"; // 숫자 카운트업 기능
import "./StatisticsSection.css";

// 아이콘 이미지 경로 설정
import icon from "../assets/2p_icon/1.jpg"
import dateInfo from "../assets/2p_icon/2.jpg"

function StatisticsSection() {
  return (
    <section className="statistics-section">
      <h2>사용률 {" "}<CountUp start={100} end={1} duration={5} />위</h2>
      <p className="subtitle">채움기획은 수치로 자신있게 공개할 수 있습니다.</p>
      <div className="icon">
        <img src={icon} alt="현재 계약 되어있는 매장 및 쇼핑몰 등"/>
      </div>
      <div className="stats-container">
        {/* 첫 번째 항목 */}
        <div className="stat-item1">
          <h3 className="first">
            네이버 플레이스{" "}
            <CountUp start={0} end={150} duration={5} />업체
          </h3>
          <h3 className="second">
            네이버 쇼핑몰{" "}
            <CountUp start={0} end={100} duration={5} />업체
          </h3>
        </div>

        {/* 두 번째 항목 */}
        <div className="stat-item2">
          <h3>
            <CountUp start={0} end={90} duration={5} />%
          </h3>
        </div>

        {/* 세 번째 항목 */}
        <div className="stat-item3">
          <h3>
            <CountUp start={0} end={999} duration={4} />+@
          </h3>
        </div>

        {/* 네 번째 항목 */}
        <div className="stat-item4">
          <h3 className="last">
            연 매출액{" "}
            <CountUp start={0} end={7} duration={5} />억 달성
          </h3>
        </div>
      </div>
      <div className="date-info">
      <img src={dateInfo} alt="통계 날짜"/>
      </div>
    </section>
  );
}

export default StatisticsSection;
